import {
  FETCH_SUGGESTED_COMPETITORS_REQUEST,
  FETCH_SUGGESTED_COMPETITORS_SUCCESS,
  FETCH_SUGGESTED_COMPETITORS_FAILURE,
} from "../actions/fetchSuggestedCompetitorActions";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const fetchSuggestedCompetitorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SUGGESTED_COMPETITORS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_SUGGESTED_COMPETITORS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };

    case FETCH_SUGGESTED_COMPETITORS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default fetchSuggestedCompetitorsReducer;
